import { createFileRoute, Link } from '@tanstack/react-router';
import { Box, VStack } from '@televet/kibble-ui/chakra';
import { Heading } from '@televet/kibble-ui/Heading';
import { Text } from '@televet/kibble-ui/Text';

const devRoutes = [{ name: 'Forms Submission', path: '/dev/forms' }];

function DevIndexRoute(): React.JSX.Element {
  return (
    <Box p={6}>
      <VStack align="start" gap={6}>
        <Heading size="lg">Pet Web Dev Routes</Heading>
        <Text color="text.subtle">
          These routes are only available when VITE_FORMS_FIXTURE_ENABLED is true.
        </Text>
        <VStack align="start" gap={2}>
          {devRoutes.map((route) => (
            <Link
              key={route.path}
              to={route.path as '/dev/forms'}
              style={{ color: '#0066cc', textDecoration: 'none' }}
            >
              {route.name}
            </Link>
          ))}
        </VStack>
      </VStack>
    </Box>
  );
}

export const Route = createFileRoute('/dev/')({
  component: DevIndexRoute,
});
